import {
    DROPSHIP_SETTING_SUCCESS,
    DROPSHIP_SETTING_FAIL,
    DROPSHIP_SETTING_LOADING,
    DROPSHIP_UPSERT_SUCCESS,
    FETCH_MY_LISTED_PRODUCTS_PENDING,
    FETCH_MY_LISTED_PRODUCTS_SUCCESS,
    FETCH_MY_LISTED_PRODUCTS_FAILED,
    FETCH_MY_LISTED_IDS_SUCCESS,
    FETCH_MY_LISTED_IDS_FAILED,
    FETCH_DROPSHIP_HISTORY_PENDING,
    FETCH_DROPSHIP_HISTORY_SUCCESS,
    FETCH_DROPSHIP_HISTORY_FAILED,
    FETCH_DROPSHIP_CATALOG_PENDING,
    FETCH_DROPSHIP_CATALOG_SUCCESS,
    FETCH_DROPSHIP_CATALOG_FAILED,
    FETCH_DROPSHIP_AGREEMENTS_PENDING,
    FETCH_DROPSHIP_AGREEMENTS_SUCCESS,
    FETCH_DROPSHIP_AGREEMENTS_FAILED,
    FETCH_SUPPLIER_ORDERS_PENDING,
    FETCH_SUPPLIER_ORDERS_SUCCESS,
    FETCH_SUPPLIER_ORDERS_FAILED,
    FETCH_MARGIN_CONFIG_PENDING,
    FETCH_MARGIN_CONFIG_SUCCESS,
    FETCH_MARGIN_CONFIG_FAILED,
} from '../actions/dropship.action';

const initialState = {
    // Settings
    setting: null,
    settingLoading: false,
    isDropshipEnabled: false,

    // My Listed Products (Day 3)
    myListedProducts: [],
    myListedProductsStatus: '',
    myListedProductsTotalRecords: 0,

    // Listed-product lookup for the inventory-grid differentiator icon
    // (keyed by inventoryProductId -> the listing record, for icon state + edit pre-fill)
    myListedMap: {},

    // Dropship listing change history (Dropshipping Settings)
    productHistory: [],
    productHistoryStatus: '',
    productHistoryTotalRecords: 0,

    // Catalog (Day 4)
    catalogList: [],
    catalogListStatus: '',
    catalogTotalRecords: 0,

    // Agreements (Day 5)
    agreementsList: [],
    agreementsListStatus: '',
    agreementsTotalRecords: 0,

    // Supplier Orders (Day 6)
    supplierOrders: [],
    supplierOrdersStatus: '',
    supplierOrdersTotalRecords: 0,

    // 3PL Margin Config
    marginConfigs: [],
    marginConfigsStatus: '',
};

const dropshipReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        // ── Settings ──────────────────────────────────────────────────────
        case DROPSHIP_SETTING_LOADING:
            return { ...state, settingLoading: true };

        case DROPSHIP_SETTING_SUCCESS:
            return {
                ...state,
                setting: payload,
                isDropshipEnabled: payload?.isDropshipEnabled || false,
                settingLoading: false,
            };

        case DROPSHIP_SETTING_FAIL:
            return { ...state, setting: null, isDropshipEnabled: false, settingLoading: false };

        case DROPSHIP_UPSERT_SUCCESS:
            return {
                ...state,
                setting: payload,
                isDropshipEnabled: payload?.isDropshipEnabled || false,
            };

        // ── My Listed Products (Day 3) ────────────────────────────────────
        case FETCH_MY_LISTED_PRODUCTS_PENDING:
            return { ...state, myListedProductsStatus: 'PENDING', myListedProducts: [] };

        case FETCH_MY_LISTED_PRODUCTS_SUCCESS:
            return {
                ...state,
                myListedProductsStatus: 'SUCCESS',
                myListedProducts: payload.list,
                myListedProductsTotalRecords: payload.totalRecords,
            };

        case FETCH_MY_LISTED_PRODUCTS_FAILED:
            return { ...state, myListedProductsStatus: 'FAILED', myListedProducts: [] };

        // ── Listed-product lookup (differentiator icon) ──────────────────
        case FETCH_MY_LISTED_IDS_SUCCESS:
            return {
                ...state,
                myListedMap: (payload.list || []).reduce((acc, item) => {
                    acc[item.inventoryProductId] = item;
                    return acc;
                }, {}),
            };

        case FETCH_MY_LISTED_IDS_FAILED:
            return { ...state, myListedMap: {} };

        // ── Dropship listing change history ──────────────────────────────
        case FETCH_DROPSHIP_HISTORY_PENDING:
            return { ...state, productHistoryStatus: 'PENDING', productHistory: [] };

        case FETCH_DROPSHIP_HISTORY_SUCCESS:
            return {
                ...state,
                productHistoryStatus: 'SUCCESS',
                productHistory: payload.list,
                productHistoryTotalRecords: payload.totalRecords,
            };

        case FETCH_DROPSHIP_HISTORY_FAILED:
            return { ...state, productHistoryStatus: 'FAILED', productHistory: [] };

        // ── Catalog (Day 4) ───────────────────────────────────────────────
        case FETCH_DROPSHIP_CATALOG_PENDING:
            return { ...state, catalogListStatus: 'PENDING', catalogList: [] };

        case FETCH_DROPSHIP_CATALOG_SUCCESS:
            return {
                ...state,
                catalogListStatus: 'SUCCESS',
                catalogList: payload.list,
                catalogTotalRecords: payload.totalRecords,
            };

        case FETCH_DROPSHIP_CATALOG_FAILED:
            return { ...state, catalogListStatus: 'FAILED', catalogList: [] };

        // ── Agreements (Day 5) ────────────────────────────────────────────
        case FETCH_DROPSHIP_AGREEMENTS_PENDING:
            return { ...state, agreementsListStatus: 'PENDING', agreementsList: [] };

        case FETCH_DROPSHIP_AGREEMENTS_SUCCESS:
            return {
                ...state,
                agreementsListStatus: 'SUCCESS',
                agreementsList: payload.list,
                agreementsTotalRecords: payload.totalRecords,
            };

        case FETCH_DROPSHIP_AGREEMENTS_FAILED:
            return { ...state, agreementsListStatus: 'FAILED', agreementsList: [] };

        // ── Supplier Orders (Day 6) ───────────────────────────────────────
        case FETCH_SUPPLIER_ORDERS_PENDING:
            return { ...state, supplierOrdersStatus: 'PENDING', supplierOrders: [] };

        case FETCH_SUPPLIER_ORDERS_SUCCESS:
            return {
                ...state,
                supplierOrdersStatus: 'SUCCESS',
                supplierOrders: payload.list,
                supplierOrdersTotalRecords: payload.totalRecords,
            };

        case FETCH_SUPPLIER_ORDERS_FAILED:
            return { ...state, supplierOrdersStatus: 'FAILED', supplierOrders: [] };

        // ── 3PL Margin Config ─────────────────────────────────────────────
        case FETCH_MARGIN_CONFIG_PENDING:
            return { ...state, marginConfigsStatus: 'PENDING', marginConfigs: [] };

        case FETCH_MARGIN_CONFIG_SUCCESS:
            return {
                ...state,
                marginConfigsStatus: 'SUCCESS',
                marginConfigs: payload.list,
            };

        case FETCH_MARGIN_CONFIG_FAILED:
            return { ...state, marginConfigsStatus: 'FAILED', marginConfigs: [] };

        default:
            return state;
    }
};

export default dropshipReducer;
